<template>
    <div class="tabs__item" :class="{'tabs__item--active':isActive}" @click="switchTab">
        {{ tab.title }}
    </div>
</template>

<script>
    import {CHANGE_ORDER_ACTION} from "VueApps/comments/actions/actions";

    export default {
        name: "TabsItem",
        props: {
            tab: {
                type: Object,
                required: true
            },
        },
        computed: {
            isActive: function () {
                return this.$store.state.componentState.order === this.tab.order
            }
        },
        methods: {
            switchTab: function () {
                this.$store.dispatch(CHANGE_ORDER_ACTION, {
                    order: this.tab.order,
                    entityId: this.$parent.$parent.entityId
                });
            },
        }
    }
</script>

<style scoped>

</style>
